window.addEventListener('load', () => {
  const url = new URL(window.location.href);
  const params = url.searchParams;
  const reffer = params.get('reffer');
  const contracts = params.getAll('id');
  const periodicId = params.get('periodic_id');

  if (!!reffer && reffer=='old-subscription') {
    $("#inflow-loading").toggle(true);
    $.ajax({
      url: window.Shopify.routes.root + 'cart/clear.js',
      type: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-HTTP-Method-Override' : 'POST',
      },
      dataType: 'json',
      success: (res) => {
        const data = contracts.map(ids => {
        const [id, quantity, selling_plan] = ids.split(',');
          return {
              'id': Number(id),
              'quantity': Number(quantity),
              'selling_plan': Number(selling_plan)
            };
        });
        let formData = {
           'items': data
        };
        
        $.ajax({
          url: window.Shopify.routes.root + 'cart/add.js',
          type: 'POST',
          async : false,
          headers: {
            'Content-Type': 'application/json',
            'X-HTTP-Method-Override' : 'POST',
          },
          dataType: 'json',
          data: JSON.stringify(formData),
          success: function (response) {
            // 商品追加後に note を設定
            $.ajax({
              url: '/cart/update.js',
              type: 'POST',
              dataType: 'json',
              data: JSON.stringify({
                note: `periodicId=${periodicId}`
              }),
              headers: {
                'Content-Type': 'application/json'
              },
              success: function () {
                location.href = `https://ifing-beauty.com/cart?reffer=hand-over&periodic_id=${periodicId}`;
                $("#inflow-loading").toggle(false);
              },
              error: function (error) {
                alert('note更新に失敗しました: ' + error.responseText);
                $("#inflow-loading").toggle(false);
              }
            });
          },
          error: (error) => {
            alert('Error:' + error.responseText);
            $("#inflow-loading").toggle(false);
          }
        });
      },
      error: (error) => {
        alert('データの取得に失敗しました'+ JSON.stringify(error));
        $("#inflow-loading").toggle(false);
      }
    });
  };

  if (!!reffer && !!periodicId && reffer=='hand-over') {
    $('#Cart-note').val(`periodicId=${periodicId}`);
    $('#Cart-note').text(`periodicId=${periodicId}`);
    $("#Cart-note").prop("readonly", true);
    $('#Cart-note').css('pointer-events', 'unset');
    $('#Cart-note').css('cursor', 'not-allowed');
    $('#Cart-note').css('background', '#eee');
    $("#inflow-loading").toggle(false);
  };
});